module.exports = __webpack_public_path__ + "media/images/icon__warning@2x-7629f7036adf906a7b0e9933c9433161.png";